import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  justify-content: flex-end;
`;
export const BotaoPDFText = styled.span `
  @media ${(props) => props.theme.device.tablet} {
    display: none;
  }
`;
export const BotaoPDFContainer = styled.div `
  display: flex;
  margin-left: 28px;
  align-items: center;
  color: ${({ theme }) => theme.titleFontColor};
  margin-bottom: 4px;
  position: relative;
  cursor: pointer;
  @media ${(props) => props.theme.device.tablet} {
    margin-left: 16px;
    margin-right: 8px;
  }
`;
